import { render, staticRenderFns } from "./DocSidebar.vue?vue&type=template&id=6351d722"
import script from "./DocSidebar.vue?vue&type=script&lang=js"
export * from "./DocSidebar.vue?vue&type=script&lang=js"
import style0 from "./DocSidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports